import {
  IAcresStat, IKilometersStat, IResortTerrainDetail, IRunsStat, ITerrrainRunsOnly,
} from 'api/resort/types';
import { useTerrainIconsUniversal } from 'components/resort/TerrainShort/useTerrainIconsUniversal';
import { useMemo } from 'react';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { ReturnBySki } from 'util/decodeReturnBySki';
import { ISlopes } from 'i18n/types';
import { slopeType } from 'i18n/preferences';

import { formatPercent } from 'util/formatPercent';
import { ReactComponent as SvgAcres } from '../../../../public/assets/icons/acres.svg';

export const useBuildTerrainIcons = ({
  data,
  resortCountry,
}: {
  data: ITerrrainRunsOnly & { acres?: IAcresStat; canReturnBySki?: ReturnBySki; km?: IKilometersStat; runs?: IRunsStat },
  resortCountry?: string
}): IResortTerrainDetail[] | null => {
  const { t } = useOTSTranslation('common');
  const slope: ISlopes = slopeType(resortCountry);

  const terrainDetails = useTerrainIconsUniversal(data, resortCountry) || [];

  const iconArray: IResortTerrainDetail[] = useMemo(() => {
    if (!slope || !resortCountry) {
      return [];
    }

    const hasOpenKm = !!data.km?.total && !!data.km?.open;
    const hasOpenAcres = !!data.acres?.open && !!data.acres.total;
    const hasOpenRuns = !!data.runs?.openPercent;

    if (hasOpenKm) {
      terrainDetails.push({
        icon: SvgAcres,
        title: t('resort.skiReport.kmOpen'),
        value: formatPercent(data.km),
      });
    }

    if (!hasOpenKm && hasOpenAcres) {
      terrainDetails.push({
        icon: SvgAcres,
        title: t('resort.skiReport.acresOpen'),
        value: formatPercent(data.acres),
      });
    }

    if (!hasOpenKm && !hasOpenAcres && hasOpenRuns) {
      terrainDetails.push({
        icon: SvgAcres,
        title: t('resort.skiReport.runsOpen'),
        value: `${data.runs?.openPercent}%`,
      });
    }

    return terrainDetails;
  }, [data, resortCountry]);

  return iconArray;
};
